"use client";

import { createAuthClient } from "better-auth/client";
import { passkeyClient } from "@better-auth/passkey/client";

/**
 * Il client di `better-auth` per il browser. **È il primo del progetto**, ed è
 * nato solo perché le chiavi d'accesso non si possono fare in nessun altro
 * modo.
 *
 * Tutto il resto di StudyHub parla col server in due modi soli: moduli HTML che
 * il browser invia da sé, e — in tre punti — una `fetch` a mano verso
 * `/api/auth/...` (vedi `ModuloPassword`). È una scelta, non una mancanza: un
 * modulo funziona anche col codice cliente spento, ed è la forma che ha salvato
 * la pagina di accesso dopo il guasto su Edge e Safari del 6 settembre 2026.
 *
 * Una chiave d'accesso invece **non esiste senza il browser**: fra la sfida
 * preparata dal server e la firma verificata dal server c'è
 * `navigator.credentials`, che gira sul dispositivo e parla con il lettore di
 * impronte. Scrivere a mano quel dialogo vorrebbe dire riscrivere
 * `@simplewebauthn/browser`, che è già qui dentro come dipendenza del modulo.
 *
 * **Da qui non passa nessuna identità.** Il client non decide chi sei: manda
 * una richiesta a `/api/auth/...` come farebbe un modulo, e il server legge la
 * sessione dal cookie come fa sempre. La regola «identità e ruolo vengono
 * sempre dalla sessione autenticata» non si sposta di un millimetro.
 *
 * Nessun `baseURL`: il valore predefinito è l'origine della pagina più
 * `/api/auth`, che è esattamente dove il gestore di rotta è montato. Scriverlo
 * vorrebbe dire portare `BETTER_AUTH_URL` dentro il codice del browser, cioè
 * far dipendere una pagina dall'ambiente in cui è stata costruita.
 */
export const clienteAuth = createAuthClient({
  plugins: [passkeyClient()],
});
